import { dateOfBirthToFormat } from 'helpers/dates';

interface ContactDateOfBirthProps {
    dob: string | null;
}
const ContactDateOfBirth = ({ dob }: ContactDateOfBirthProps) => {
    const formattedDob = dateOfBirthToFormat(dob ?? '', {
        long: 'MMMM dd, yyyy',
        short: 'MMMM dd',
    });

    return formattedDob || null;
};

export { ContactDateOfBirth };
